<ng-container *transloco="let t">
  <form id="inputForm" [formGroup]="inputForm" (ngSubmit)="submit()">
    <div class="row text-center justify-content-center mt-3">
      <div class="col-8 col-sm-4 col-md-3 col-lg-2">
        <mat-button-toggle-group name="value" formControlName="value" class="w-100">
          <mat-button-toggle value="false" #no class="w-50 warn-important {{no.checked ? 'selected' : ''}}">
            {{t('common.no')}}
          </mat-button-toggle>
          <mat-button-toggle value="true" #yes class="w-50 accent-important {{yes.checked ? 'selected' : ''}}">
            {{t('common.yes')}}
          </mat-button-toggle>
        </mat-button-toggle-group>
      </div>
    </div>
  </form>
</ng-container>
